<template>
  <div class="card mb-3">
    <div class="card-body">
      <h3>Reset Transactions</h3>
      <div class="row">
        <div class="col-md-12">
          <a-steps class="steps-navigator" :current="currentTab" @change="onChangeTab">
            <a-step title="Step 1" description="Select Account, Site and Terminal to Reset" />
            <a-step title="Step 2" description="Review Information and Confirm Password" />
            <a-step title="Step 3" description="Proceed to Reset Transaction" :disabled="currentTab == 0" />
          </a-steps>

          <div v-if="currentTab == 0" class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <base-input label="Account Selection:">
                    <a-select showSearch style="width: 100%" placeholder="" optionFilterProp="children" v-model="selectedAccount">
                      <a-select-option v-for="(account, index) in accounts" :key="index" :value="account.id">
                        {{account.account_name}}
                      </a-select-option>
                    </a-select>
                  </base-input>
                </div>

                <div class="col-md-12">
                  <base-input label="Site:">
                    <a-select showSearch style="width: 100%" placeholder="" optionFilterProp="children" v-model="selectedSite">
                      <a-select-option v-for="(site, index) in sites" :key="index" :value="site.id">
                        {{site.name}}
                      </a-select-option>
                    </a-select>
                  </base-input>
                </div>

                <div class="col-md-12">
                  <base-input label="Terminal:">
                    <a-select showSearch style="width: 100%" placeholder="" optionFilterProp="children" v-model="selectedTerminal">
                      <a-select-option v-for="(terminal, index) in terminals" :key="index" :value="terminal.id">
                        {{terminal.name}}
                      </a-select-option>
                    </a-select>
                  </base-input>
                </div>
              </div> <!-- <div class="row"> -->

              <div class="row">
                <div class="col-md-12">
                  <h4>Terminal Reset</h4>
                  <a-checkbox v-model="is_sales_included">
                    <strong>Sales Transactions</strong>
                  </a-checkbox>
                </div>
                <div class="col-md-12">
                  <h4 class="mt-2">Site Reset</h4>
                  <a-checkbox v-model="is_inventory_included">
                    <strong>Inventories</strong>
                  </a-checkbox>
                </div>
                <div class="col-md-12">
                  <a-checkbox v-model="is_pws_included">
                    <strong>Price Work Sheet</strong>
                  </a-checkbox>
                </div>
              </div>
            </div> <!-- <div class="col-md-12"> -->
          </div> <!-- <div :v-if="currentTab == 0" class="row"> -->

          <div v-if="currentTab == 1" class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <p class="header">
                    Kindly thoroughly check all the information needed to Reset Transaction. 
                    <span style='color: #ff0000'>* Keep in mind that there is no revert process after the reset. *</span>
                  </p>
                  <small class="selectedInfo-cont">
                    <div>
                      <b>Account:</b> {{ selectedInfo.accountName }}
                    </div>

                    <div>
                      <b>Site:</b> {{ selectedInfo.siteName }}
                    </div>

                    <div>
                      <b>Terminal:</b> {{ selectedInfo.terminal }}
                    </div>
                    
                    <div>
                      <b>Clear Sales Transactions:</b> {{ selectedInfo.clearSales }}
                    </div>

                    <div>
                      <b>Clear Inventory:</b> {{ selectedInfo.clearInventory }}
                    </div>

                    <div>
                      <b>Clear Price Work Sheet:</b> {{ selectedInfo.clearPws }}
                    </div>
                  </small>
                </div>
              </div> <!-- <div class="row"> -->

              <div class="row mt-2">
                <div class="col-md-12">
                  <p class="header">
                    If all listed information is okay, please confirm your password and click Proceed and the Reset process will start.
                  </p>

                  <base-input class="mt-3" alternative="" label="Confirm Password" placeholder="**********" type="password" v-model="password" input-classes="form-control" required/>
                </div>
              </div>
            </div> <!-- <div class="col-md-12"> -->
          </div> <!-- <div :v-if="currentTab == 1" class="row"> -->

          <div v-if="currentTab == 2" class="row">
            <div class="col-md-12">
              <div class="row">
                
              </div> <!-- <div class="row"> -->
            </div> <!-- <div class="col-md-12"> -->
          </div> <!-- <div :v-if="currentTab == 2" class="row"> -->
        </div> <!-- <div class="col-md-12"> main col -->
      </div> <!-- div.col-md-12 <h3>Reset Trsansactions</h3> -->
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import HTTPRequest from '../../controllers/httpRequest.js';
  import secureStorage from '../../controllers/secureStorage.js';
  import axios from "axios";

  export default{
    data() {
      return {
        currentTab: 0,
        terminals: [],
        selectedAccount: null,
        selectedTerminal: null,
        selectedSite: null,
        maxTab: 2,
        selectedInfo: {},
        accounts: {},
        sites: {},
        terminals: {},
        is_sales_included: true,
        is_inventory_included: true,
        is_pws_included: true,
        password: '',
      }
    },
    computed: {
      ...mapState(['endPoint'])
    },
    watch: {
      selectedAccount: function() {
        if (!this.selectedAccount) { return; }
        this.selectedSite = null;
        this.populateSites();
      },
      selectedSite: function() {
        this.terminals = [];
        this.selectedTerminal = null;

        if (this.selectedSite) {
          this.populateTerminals();
        }
      },
      currentTab: function(){
        if(this.currentTab == 1){
          this.setSelectedInfo();
        } else if (this.currentTab == 2) {
          this.checkPassword();
        }
      }
    },
    mounted: async function() {
      await this.populateAccounts();
    },
    methods: {
      onChangeTab(current) {
        const hasErrors = this.isNotValid();
        if (hasErrors) { return; }
        this.currentTab = current;
      },
      isNotValid: function() {
        let withError = false;
        if (!this.selectedAccount) {
          this.renderMsg('error', 'Error', 'Please Select an Account');
          withError = true;
        } else if (!this.selectedSite) {
          this.renderMsg('error', 'Error', 'Please Select a Site');
          withError = true;
        } else if (this.selectedTerminal == null) {
          this.renderMsg('error', 'Error', 'Please Select a Terminal');
          withError = true;
        }

        return withError;
      },
      renderMsg(type, msg, desc) {
        this.$notification[type]({ message: msg, description: desc, });
      },
      async populateAccounts() {
        // Get all Valid and Active accounts
        let accounts = await HTTPRequest.getRequest(`${this.endPoint}accounts/get_valid_accounts`, null, null)
        accounts = accounts.sort((a, b) => {
          const textA = a.account_name.toUpperCase();
          const textB = b.account_name.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        this.accounts = accounts || [];
      },
      async populateSites() {
        if (!this.selectedAccount) { return; }

        const sites = await HTTPRequest.getRequest(`${this.endPoint}sites/get_sites_with_terminal?account_id=${this.selectedAccount}`, null, null)
        this.sites = sites || [];
        this.sort(this.sites);
      },
      async populateTerminals() {
        const terminals = await HTTPRequest.getRequest(`${this.endPoint}terminals?account_id=${this.selectedAccount}&site_id=${this.selectedSite}`, null, null)
        this.terminals = (terminals || {}).data || [];
        this.terminals.push({id: 0, name: ' All Terminals'})
        this.sort(this.terminals);
      },
      sort(data){
        data.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
      },
      setSelectedInfo() {
        const selectedAccount = this.accounts.filter(account => account.id == this.selectedAccount)[0];
        const selectedSite = this.sites.filter(site => site.id == this.selectedSite)[0];
        const selectedTerminal = this.terminals.filter(terminal => terminal.id == this.selectedTerminal)[0];

        this.selectedInfo = {
          accountName: selectedAccount.account_name,
          siteName: selectedSite.name,
          terminal: selectedTerminal.name,
          clearInventory: this.is_inventory_included,
          clearSales: this.is_sales_included,
          clearPws: this.is_pws_included
        }
      },
      checkPassword: async function() {
        this.loading = true;

        if (this.validatePassword()) {
          this.loading = false;
          this.currentTab = 1;
          return;
        }

        let form = new FormData();
        form.append('password', this.password);

        const passwordRequest = await HTTPRequest.postRequest(`${this.endPoint}admin/check_admin_password`, null, form);

        this.loading = false;
        if (passwordRequest.success) {
          await this.proceed();
        } else if (passwordRequest.error) {
          this.renderMsg('error', 'Error', passwordRequest.error);
          this.currentTab = 1;
        } else {
          this.renderMsg('error', 'Error', 'Something Went Wrong on Confirming your Password.');
          this.currentTab = 1;
        }
      },
      validatePassword() {
        const passwordRegex = /^[a-zA-Z0-9!?@]+$/i;
        const password = this.password;
        let hasError = false;

        if (password.trim().length == 0) {
          this.renderMsg('error', 'Error', "Password can't be blank.");
          hasError = true;
        }

        if (password.trim().length > 0) {
          if (password.match(passwordRegex) == null) {
            this.renderMsg('error', 'Error', 'Password must only contain Alphanumeric and any of the following special characters: !?@');
            hasError = true;
          }

          else if (password.length < 8) {
            this.renderMsg('error', 'Error', 'Password must contain at least 8 characters');
            hasError = true;
          }
        }
        return hasError;
      },
      proceed: async function() {
        this.loading = true;
        let form = new FormData();
        form.append('account_id', this.selectedAccount);
        form.append('site_id', this.selectedSite)
        form.append('terminal_id', this.selectedTerminal);
        form.append('is_sales_included', this.is_sales_included);
        form.append('is_inventory_included', this.is_inventory_included);
        form.append('is_pws_included', this.is_pws_included);

        const resetRequest = await HTTPRequest.postRequest(`${this.endPoint}accounts/reset_transactions`, null, form);
        
        this.loading = false;
        this.loading = false;
        if (resetRequest.success) {
          this.renderMsg('success', 'Success', resetRequest.msg);
          this.currentTab = 0;
        } else if (resetRequest.error) {
          const err = resetRequest.error
          const error_arr = err.split(',');

          for(let i=0; i < error_arr.length; i++){
            this.renderMsg('error', 'Error', error_arr[i]);  
          }
          
          this.currentTab = 1;
        } else {
          this.renderMsg('error', 'Error', 'Something Went Wrong while resetting transactions.');
          this.currentTab = 1;
        }
      }
    }
  }
</script>
<style scoped>
  .steps-navigator {
    margin-bottom: 20px;
  }

  p.header {
    font-size: 14px;
  }

  .selectedInfo-cont {
    display: inline-block;
    margin-left: 10px;
  }

  .selectedInfo-cont div {
    margin-bottom: 10px;
  }
</style>